import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { IeBlocker } from "@nswdoe/doe-ui-core";
import api from "./api";
import i18n from "./i18n";

/**
 * The mixin for implementing dynamic <title> in SPA according to different 'view/page' the user views.
 * It's to support better accessibility.
 * The mixin is from the official doc https://ssr.vuejs.org/guide/head.html
 */
import titleMixin from "./mixins/titleMixin";
Vue.mixin(titleMixin);

import { getCookie, setCookie, deleteCookie } from "./mixins/cookies";
import formatDate from "./mixins/formatDate";
Vue.mixin({
  methods: {
    getCookie,
    setCookie,
    deleteCookie,
    getLocale,
    formatDate,
    analytics,
    remoteConfig
  }
});

let renderComponent, renderProps;
if (IeBlocker.isIe()) {
  // render IeBlocker
  renderComponent = IeBlocker;
  renderProps = {
    props: { block: true, appName: "Parent App" }
  };
} else {
  // render App
  renderComponent = App;
  renderProps = {};
  // Config the App root instance (oAuth plugin, etc.)
  Vue.config.productionTip = false;

  Vue.prototype.$eventHub = new Vue();

  // Unified interface for API requests
  Vue.prototype.$api = api;
}
window.onNativeEvent = function(event) {
  if (event) {
    if (!event.error && event.type === "login") {
      analytics("my_account", { sign_in: "success" });
      store.dispatch("fetchUserData");
    }
  }
};
import infiniteScroll from "vue-infinite-scroll";
import { analytics } from "@/mixins/analytics";
import { remoteConfig } from "@/mixins/remoteConfig";
import { getLocale } from "@/mixins/locale";
Vue.use(infiniteScroll);
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(renderComponent, renderProps)
}).$mount("#app");
